import React from 'react'
import styled from 'styled-components'

import { Tooltip } from '@sketch/components'
import { useGetUnreadNotificationsCount } from '@sketch/modules-common'

import { ReactComponent as MarkAllReadIconSvg } from '@sketch/icons/double-check-17'

import { InboxHeaderButton } from './Inbox.styles'
import { useMarkAllAsRead } from './useMarkAllAsRead'

const MarkAllReadIcon = styled(MarkAllReadIconSvg)`
  width: 24px;
  height: 24px;
`

export const InboxMarkAllAsReadButton = () => {
  const unreadCount = useGetUnreadNotificationsCount()
  const [markAllAsRead, { loading }] = useMarkAllAsRead()

  const disabled = unreadCount === 0

  return (
    <Tooltip
      content="Mark all as read"
      disabled={disabled}
      placement="bottom"
      disableWhenTouchDevice
    >
      <InboxHeaderButton
        aria-label="Mark all as read"
        disabled={disabled}
        loading={loading}
        onClick={() => markAllAsRead()}
      >
        <MarkAllReadIcon />
      </InboxHeaderButton>
    </Tooltip>
  )
}
